import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const NotificationsMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationsMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketingOptIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"optedIn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messagesDismissed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minutesBetweenSummaries"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"NotificationsMenu","document":NotificationsMenuDocument}} as const;
export type NotificationsMenuQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type NotificationsMenuQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'confirmed' | 'id'>
    & { marketingOptIn?: Types.Maybe<(
      { __typename: 'Member_MarketingOptIn' }
      & Pick<Types.Member_MarketingOptIn, 'date' | 'optedIn'>
    )>, messagesDismissed?: Types.Maybe<Array<(
      { __typename: 'Member_MessageDismissed' }
      & Pick<Types.Member_MessageDismissed, 'name'>
    )>>, prefs?: Types.Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Types.Member_Prefs, 'minutesBetweenSummaries'>
    )> }
  )> }
);




/**
 * __useNotificationsMenuQuery__
 *
 * To run a query within a React component, call `useNotificationsMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsMenuQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useNotificationsMenuQuery(baseOptions: Apollo.QueryHookOptions<NotificationsMenuQuery, NotificationsMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsMenuQuery, NotificationsMenuQueryVariables>(NotificationsMenuDocument, options);
      }
export function useNotificationsMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsMenuQuery, NotificationsMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsMenuQuery, NotificationsMenuQueryVariables>(NotificationsMenuDocument, options);
        }
export type NotificationsMenuQueryHookResult = ReturnType<typeof useNotificationsMenuQuery>;
export type NotificationsMenuLazyQueryHookResult = ReturnType<typeof useNotificationsMenuLazyQuery>;
export type NotificationsMenuQueryResult = Apollo.QueryResult<NotificationsMenuQuery, NotificationsMenuQueryVariables>;